// user 資訊彈窗
import UserInfo from './user/UserInfo'; // 使用者 名稱 uid 星塵資訊
import LogoutButton from '../user/LogoutButton'; // 登出按鈕
import UserToggleAdultButton from './user/UserToggleAdultButton'; // 成人模式切換按鈕
import UserMemberLink from './user/UserMemberLink'; // 會員系統連結

export default function UserModal({ dispatch, t, setShowUserModal, showUserModal, user }) {
    const onClose = () => dispatch(setShowUserModal(false));

    return (
        <>
            <div
                className={`p-[20px] z-[20] absolute right-[4px] rounded-[12px] bg-white shadow-[0_0_20px_0_rgba(80,80,80,0.25)] w-[266px] ulg:z-[9] ulg:fixed
                trans ${
                    showUserModal
                        ? 'top-[55px] ulg:bottom-[58px]'
                        : 'top-[-670px] ulg:bottom-[-670px]'
                }
                ulg:!top-[unset] ulg:right-[0] ulg:w-full ulg:rounded-none ulg:shadow-none ulg:border-t-1 ulg:border-black1`}
            >
                {/* 使用者 名稱 uid 星塵資訊 */}
                <UserInfo t={t} user={user} />

                {/* 成人模式切換按鈕 */}
                <UserToggleAdultButton t={t} />

                {/* 會員系統連結 */}
                <UserMemberLink t={t} uid={user?.uid} />

                {/* 登出按鈕 */}
                <LogoutButton t={t} />
            </div>

            {showUserModal && (
                <>
                    <div className="fixed top-0 left-0 w-full h-[54px] z-[22]" onClick={onClose} />
                    <div className="fixed top-0 left-0 z-[8] w-full h-full" onClick={onClose} />
                </>
            )}
        </>
    );
}
